import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { api } from "../../../../../api";
import { extractCenterId } from "../../../../../utils/center";
import { isMissingQueueEnforced } from "../../../../../utils/permissions";
import { deliveryUpdateSucceeded } from "../../../actions/deliveries";
import { PriorityToggle } from "../../WaitingProducts/WaitingProductsRow";

// Interrupteur de priorité d'attente sur une ligne de dock (commande en attente de produits)
const WaitingPriorityCell = ({ task, centerId, canOrder, enforced, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  if (!enforced || !task.linked_order || task.linked_order.status !== "waiting-products") return null;

  const onChange = (orderId, priority) => {
    setBusy(true);
    api.setWaitingPriorityByOrder(centerId, orderId, priority)
      .then(() => onUpdated([Object.assign({}, task, { waiting_priority: priority })]))
      .catch(() => {})
      .then(() => setBusy(false));
  };

  return (
    <PriorityToggle
      taskId={task.linked_order.id}
      value={task.waiting_priority || 0}
      canOrder={canOrder}
      busy={busy}
      onChange={onChange}
    />
  );
};

WaitingPriorityCell.propTypes = {
  task: PropTypes.object.isRequired,
  centerId: PropTypes.number,
  canOrder: PropTypes.bool,
  enforced: PropTypes.bool,
  onUpdated: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const groups = (state.user && state.user.groups) || {};
    return {
      centerId: extractCenterId(state.user),
      canOrder: !!groups.can_order_waiting_products,
      enforced: isMissingQueueEnforced(state),
    };
  },
  (dispatch) => ({
    onUpdated: (tasks) => dispatch(deliveryUpdateSucceeded(tasks)),
  })
)(WaitingPriorityCell);
